import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { deleteFundingRequest, resetDeleteFundingRequest } from "./delete-funding-request";

const initialState: ProcessingState = {
  processing: "idle",
};

export const deleteFundingRequestReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(deleteFundingRequest.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(deleteFundingRequest.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(deleteFundingRequest.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetDeleteFundingRequest, () => {
    return initialState;
  });
});
